module.exports = __webpack_public_path__ + "a38664f809324de8febb61fb14fa8f6e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/bg_large.jpg
 ** module id = 60
 ** module chunks = 0
 **/